<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <v-flex xs12 class="mb-4">
        <div class style="position: relative;">
          <div class="flex-container-space-between vertical-center-container" v-if="!!report">
            <div>
              <layout-no-padding>
                <v-icon
                  class="pr-2"
                  :color="$store.state.global.pages.showReport.color"
                >{{$store.state.global.pages.showReport.icon}}</v-icon>
                <h1
                  class="title grey--text text--darken-1 vertical-center-container mt-1"
                >{{report.title}}</h1>
              </layout-no-padding>
              <div class="body-2 grey--text mt-2">{{report.type.toUpperCase()}}</div>
            </div>
          </div>
          <div v-else>
            <div class="body-2 grey--text">No report selected</div>
          </div>
          <div
            style="width:100%; height:1px; margin-top: 15px; margin-bottom: 15px;"
            class="grey lighten-1"
          ></div>
        </div>
      </v-flex>
      <!-- <report-view-component>
      </report-view-component>-->
      <report-view :is="DynamicViewComponent"></report-view>
    </v-layout>
  </v-container>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import RctiView from "@/components/rctis/rctiView";
import ReportService from "@/services/requests/reportService";
export default {
  name: "ShowReport",
  data() {
    return {
      headers: [],
      newHeaders: []
    };
  },
  methods: {
    initReport() {
      this.loading = true;
      ReportService.getReportData(this.report)
        .then(result => {
          this.reportDialog = false;
          this.reportDisplayDialog = true;
          this.reportData = result.data.result;
          this.loading = false;
        })
        .catch(err => {
          this.snackError();
          this.loading = false;
          console.log(err);
        });
    }
  },
  computed: {
    report() {
      var report = this.$route.query.report;
      if (!!report && !!Object.keys(report).length) {
        return JSON.parse(this.$route.query.report);
      } else {
        return null;
      }
    },
    viewComponentPath() {
      if (!this.report) return "rctis/rctiView";
      if (this.report.type == "rcti") return "rctis/rctiView";
      if (this.report.type == "allocation") return "allocations/allocationView";
    },
    loading: {
      get() {
        return this.$store.state[`${this.report.type}`].loading;
      },
      set(val) {
        this.$store.commit(`${this.report.type}/setState`, {
          prop: "loading",
          value: val
        });
      }
    },
    reportData: {
      get() {
        return this.$store.state[`${this.report.type}`][`${this.report.type}`];
      },
      set(val) {
        this.$store.commit(`${this.report.type}/setState`, {
          prop: this.report.type,
          value: val
        });
      }
    },
    DynamicViewComponent() {
      var path;
      !!this.report
        ? (path = `${this.report.type}/${this.report.type.substring(
            0,
            this.report.type.length - 1
          )}View`)
        : (path = "rctis/rctiView");
      return () => import("@/components/" + path);
    }
  },
  mounted() {
    if (!!this.report) {
      this.initReport();
    }
  },
  beforeDestroy() {
    //console.log(this.report.type);
    //this.reportData = [];
  }
};
</script>

<style>
</style>
